import { PencilIcon, TrashIcon } from "@heroicons/react/24/outline";
import React, { useEffect, useRef } from "react";
import Loader from "../../components/loader";
import NoData from "../../components/noData";
import { useNCallContext } from "../../context/ncall-context";
import { API } from "../../service/api";
import { showErrorToast, showSuccessToast } from "../../utils/toast";
import Modal from "../../components/modal/modal";
import Table from "../../components/table";
import { useNavigate } from "react-router-dom";
import ConfirmationModal from "../../components/modal/confirmationModal";
// modal config
const config = {
  title: "",
  handler: null,
};

const Departments = () => {
  const { state, openModal, setOpenModal, getDepartments, getColors } =
    useNCallContext();
  const { departments } = state;
  let _id = "";
  const confirmationmodalRef = useRef(null);
  const departmentRef = useRef();
  const colorRef = useRef();
  // const statusIdRef = useRef();

  const navigate = useNavigate();
  useEffect(() => {
    if (localStorage.getItem("logged-in-as") == "client") {
      navigate("/client");
    }
  }, []);
  const getColorName = (code) => {
    let _color = state.colors.find((color) => color.hexcode === code);
    return _color?.name;
  };

  const handleUpdateBtnClk = (department) => {
    departmentRef.current = department.department;
    colorRef.current = department.color;
    // statusIdRef.current = department.statusId;
    _id = department.id;

    config.title = "Update Department";
    config.handler = handleUpdateDepartment;

    setOpenModal(!openModal);
  };

  const openDeletionConfirmationModal = (department) => {
    if (confirmationmodalRef) {
      confirmationmodalRef.current.handleModalOpen();
      confirmationmodalRef.current.setRecordForModal(department);
      confirmationmodalRef.current.setHandlerMethod(() => handleDeleteBtnClk);
    }
  };

  const handleDeleteBtnClk = async (department) => {
    try {
      const res = await API.deleteDepartments(department.id);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
      getDepartments();
    } catch (error) {
      showErrorToast(error.message);
    }
  };

  const handleUpdateDepartment = async () => {
    let data = {
      department: departmentRef.current.value,
      color: colorRef.current.value,
      statusId: "",
    };

    try {
      const res = await API.putDepartments(_id, data);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }

      getDepartments();
    } catch (error) {
      showErrorToast(error.message);
    }
    // setRefresh(!refresh);
  };

  const handleAddDepartment = async () => {
    let data = {
      department: departmentRef.current.value,
      color: colorRef.current.value,
      statusId: "",
    };
    try {
      const res = await API.postDepartments(data);
      if (res.error) {
        showErrorToast(res.message);
      } else {
        showSuccessToast(res.message);
      }
      getDepartments();
    } catch (error) {
      showErrorToast(error.message);
    }
    // setRefresh(!refresh);
  };

  useEffect(() => {
    localStorage.setItem(
      "sort",
      JSON.stringify({ id: "statusId", desc: false })
    );
    getDepartments();
    if (state.colors.length === 0) {
      getColors();
    }
  }, []);

  const columns = React.useMemo(
    () => [
      {
        Header: "Name",
        accessor: "department",
      },
      {
        Header: "Status ID",
        accessor: "statusId",
      },
      {
        Header: "Color",
        accessor: "color",
        Cell: ({ value }) => {
          return (
            <div className="flex gap-1 justify-start items-center">
              <div className="h-5 w-5" style={{ backgroundColor: value }}></div>
              <div>{getColorName(value)}</div>
            </div>
          );
        },
      },
    ],
    []
  );

  const actions = [
    {
      icon: PencilIcon,
      handler: handleUpdateBtnClk,
      styles: "w-5 h-5 text-green-500",
    },
    {
      icon: TrashIcon,
      handler: openDeletionConfirmationModal,
      styles: "w-5 h-5 text-red-500",
    },
  ];

  if (state.loading) return <Loader />;

  return (
    <div className="">
      {<ConfirmationModal ref={confirmationmodalRef} />}
      {/* Modal  */}
      {openModal ? (
        <Modal config={config}>
          {/* Department Name */}
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <label
              htmlFor="department"
              className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              Name
            </label>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <input
                ref={departmentRef}
                required
                defaultValue={departmentRef.current}
                type="text"
                name="department"
                id="department"
                className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
              />
            </div>
          </div>
          {/* Color */}
          <div className="sm:grid sm:grid-cols-3 sm:items-start sm:gap-4  sm:border-gray-200 sm:pt-5">
            <label
              htmlFor="department"
              className="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"
            >
              Color
            </label>

            <div className="mt-1 sm:col-span-2 sm:mt-0">
              <select
                ref={colorRef}
                defaultValue={colorRef.value}
                name="color"
                id="color"
                className="block w-full max-w-lg rounded-md border-gray-300 shadow-sm focus:border-indigo-500 focus:ring-indigo-500 sm:max-w-xs sm:text-sm"
              >
                {state.colors.map((option, index) => (
                  <option value={option.hexcode} key={index}>
                    {option.name}
                  </option>
                ))}
              </select>
            </div>
          </div>
        </Modal>
      ) : (
        ""
      )}
      <div className="sm:flex sm:items-center">
        <div className="sm:flex-auto">
          <h1 className="text-base font-semibold leading-6 text-gray-900">
            Departments
          </h1>
        </div>
        <div className="mt-4 sm:mt-0 sm:ml-16 sm:flex-none">
          <button
            onClick={() => {
              config.title = "Add New Department";
              config.handler = handleAddDepartment;

              setOpenModal(!openModal);
            }}
            type="button"
            className="block rounded-md bg-indigo-600 py-2 px-3 text-center text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
          >
            Add Department
          </button>
        </div>
      </div>
      {!state.loading && departments.length == 0 ? (
        <NoData message={"You don't have any departments."} />
      ) : (
        <div className="mt-8 flow-root">
          <div className="-my-2 -mx-4 overflow-x-auto sm:-mx-6 lg:-mx-8">
            <div className="inline-block min-w-full py-2 align-middle sm:px-6 lg:px-8">
              <Table
                columns={columns}
                data={state?.departments}
                actions={actions}
                name="departments"
              />
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Departments;
